module.exports = __webpack_public_path__ + "static/pic02-4ea4cac852fcf78faedfca6c21408fec.jpg";